import { genSurfaceContextFn, compose } from "../generators/index";
var BACKGROUND_COLOR_CLICK_NEUTRAL = {
    key: 'clickNeutral',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'neutral.15',
        active: 'neutral.30',
        focus: 'neutral.15',
        disabled: 'neutral.zero',
        surface: 'neutral.13'
    }
};
var BACKGROUND_COLOR_CLICK_HARD_NEUTRAL = {
    key: 'clickHardNeutral',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'neutral.150',
        active: 'neutral.150',
        focus: 'neutral.150',
        disabled: 'neutral.zero',
        surface: 'neutral.30'
    }
};
var BACKGROUND_COLOR_NEUTRAL_FILL = {
    key: 'fillNeutral',
    backgroundColor: {
        base: 'neutral.45',
        hover: 'neutral.70',
        active: 'neutral.100',
        focus: 'neutral.70',
        disabled: 'neutral.45',
        surface: 'neutral.150'
    }
};
var BACKGROUND_COLOR_SELECT_LIST = {
    key: 'selectList',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'neutral.15',
        active: 'interactive.13',
        focus: 'neutral.15',
        disabled: 'neutral.zero'
    }
};
var BACKGROUND_COLOR_SELECT_TOGGLE = {
    key: 'selectToggle',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'neutral.zero',
        active: 'interactive.45',
        focus: 'neutral.zero',
        disabled: 'neutral.zero'
    }
};
var BACKGROUND_COLOR_SELECT_TACTILE = {
    key: 'selectTactile',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'interactive.10',
        active: 'interactive.45',
        focus: 'interactive.10',
        disabled: 'neutral.zero'
    }
};
var BACKGROUND_COLOR_SELECT = {
    key: 'select',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'interactive.45',
        active: 'interactive.45',
        focus: 'interactive.45',
        disabled: 'neutral.zero'
    }
};
var BACKGROUND_COLOR_INTERACTIVE_FILL = {
    key: 'interactiveFill',
    backgroundColor: {
        base: 'interactive.10',
        hover: 'interactive.13',
        active: 'interactive.15',
        focus: 'interactive.13',
        disabled: 'interactive.10',
        surface: 'interactive.13'
    }
};
var BACKGROUND_COLOR_CLICK = {
    key: 'click',
    backgroundColor: {
        base: 'interactive.45',
        hover: 'interactive.70',
        active: 'interactive.100',
        focus: 'interactive.70',
        disabled: 'interactive.45'
    }
};
var BACKGROUND_COLOR_CLICK_HARD = {
    key: 'clickHard',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'interactive.45',
        active: 'interactive.70',
        focus: 'interactive.45',
        disabled: 'neutral.zero'
    }
};
var BACKGROUND_COLOR_CLICK_SOFT = {
    key: 'clickSoft',
    backgroundColor: {
        base: 'neutral.zero',
        hover: 'interactive.10',
        active: 'interactive.15',
        focus: 'interactive.10',
        disabled: 'neutral.zero',
        surface: 'interactive.15'
    }
};
export function backgroundColorClickNeutralContext(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_CLICK_NEUTRAL)(t);
}
export function backgroundColorClickHardNeutralContext(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_CLICK_HARD_NEUTRAL)(t);
}
export function backgroundColorNeutralFill(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_NEUTRAL_FILL)(t);
}
export function backgroundColorSelectList(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_SELECT_LIST)(t);
}
export function backgroundColorSelectToggle(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_SELECT_TOGGLE)(t);
}
export function backgroundColorSelectTactile(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_SELECT_TACTILE)(t);
}
export function backgroundColorSelect(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_SELECT)(t);
}
export function backgroundColorInteractiveFill(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_INTERACTIVE_FILL)(t);
}
export function backgroundColorClick(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_CLICK)(t);
}
export function backgroundColorClickHard(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_CLICK_HARD)(t);
}
export function backgroundColorClickSoft(t) {
    return genSurfaceContextFn(BACKGROUND_COLOR_CLICK_SOFT)(t);
}
export function generateAllBackgroundRamps(t) {
    return compose(backgroundColorSelectList, backgroundColorSelectToggle, backgroundColorSelectTactile, backgroundColorSelect, backgroundColorInteractiveFill, backgroundColorClick, backgroundColorClickHard, backgroundColorClickSoft, backgroundColorClickNeutralContext, backgroundColorClickHardNeutralContext, backgroundColorNeutralFill)(t);
}
